export default "<carousel-section>@{}</carousel-section>";